import React, { useEffect } from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import WeaveTypeInputs from '../../components/WeaveTypeInputs/WeaveTypeInputs';
import { updateWeaveTypeRequestAction } from '../../store/weaveType/weaveTypeActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateWeaveType = ({ updateWeaveTypeRequest, isLoading, updateWeaveTypeData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const weaveTypeData = location.state?.weaveType || null;

  useEffect(() => {
    if (!weaveTypeData && id) {
      console.warn('No weave type data found in route state. You may need to fetch by ID:', id);
    }
  }, [weaveTypeData, id]);

  const handleSubmit = (data) => {
    updateWeaveTypeRequest({
      data,
      navigate
    });
  };

  const handleCancel = () => {
    navigate('/weavetype');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem 
          href="#/weavetype" 
          onClick={(e) => {
            e.preventDefault();
            handleCancel();
          }}
        >
          {t('weaveType')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateWeaveType')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">{t('updateWeaveType')}</h4>
                {weaveTypeData?.WeaveTypeId && (
                  <small className="text-muted">
                    ID: {weaveTypeData.WeaveTypeId}
                  </small>
                )}
              </div>
            </CCardHeader>
            <CCardBody>
              {weaveTypeData ? (
                <WeaveTypeInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateWeaveTypeData}
                  initialData={weaveTypeData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <div className="text-muted">
                    No weave type data found. Please go back to the list.
                  </div>
                  <button className="btn btn-primary mt-3" onClick={handleCancel}>
                    Back to Weave Types
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateWeaveTypeData: state.weaveTypeReducer.updateWeaveTypeData,
});

const mapDispatchToProps = {
  updateWeaveTypeRequest: updateWeaveTypeRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateWeaveType);
